import Cookies from 'js-cookie';
export default {
    init() {
        if (window.site_util.user_status === '1') {
            Cookies.remove('Adviser');
        }

        $('*[data-userservice="select"]').each(function () {
            const that = $(this);

            switch (that.data('userservice')) {
                case 'select':

                    if (typeof Cookies.get('Adviser') !== 'undefined' && window.site_util.user_status !== '1') {
                        let adviser = window.JSON.parse(window.atob(Cookies.get('Adviser')));
                        that.find('option[value=' + adviser +']').attr('selected', true)
                    }

                    that.on('change', function () {
                        let adviser_id = $(this).val();
                        let data = {
                            cookie:'Adviser',
                            value: adviser_id,
                            action:'setcookie',
                        };

                        $.ajax({
                            url: window.site_util.ajax_url,
                            type: 'get',
                            data: data,
                            dataType: 'json',
                            beforeSend: function (){},
                            success:function (response) {
                                if (!response) {
                                    console.log('ERROR!');
                                } else {
                                    let body = $('body');
                                    if (body.hasClass('woocommerce-checkout')) {
                                        body.trigger('update_checkout');
                                    }
                                }
                            },
                        });
                    });

                    break;
            }
        });
    },

    finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/userService.js